import { ONE_LOGIN_AUTHORITY } from "../constants";
export function createLoginUrl(clientId, redirectUrl, state, nonce) {
    const params = new URLSearchParams();
    params.append("client_id", clientId);
    params.append("redirect_uri", redirectUrl);
    params.append("response_type", "id_token token");
    params.append("scope", "openid profile");
    params.append("state", state);
    params.append("nonce", nonce);
    return `${ONE_LOGIN_AUTHORITY}/auth?${params.toString()}`;
}
export function createLogOutUrl(redirectUrl, idToken, state) {
    const params = new URLSearchParams();
    params.append("post_logout_redirect_uri", redirectUrl);
    params.append("state", state);
    params.append("id_token_hint", idToken);
    params.append("logout", "true");
    return `${ONE_LOGIN_AUTHORITY}/logout?${params.toString()}`;
}
//# sourceMappingURL=oneLogin.js.map